import React, { useState, useEffect } from 'react';
import { Building2, Edit2, PlusCircle, ArrowLeft, FileDown, Trash2, ArrowUpDown, ToggleLeft, ToggleRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from './config';

function FirmaYonetimi({ user }) {
    const isAdmin = user?.rol === 'Admin';
    const [firmalar, setFirmalar] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [searchAd, setSearchAd] = useState('');
    const [searchYetkili, setSearchYetkili] = useState('');
    const [durumFilter, setDurumFilter] = useState('');
    const [showPasif, setShowPasif] = useState(false);

    const [formData, setFormData] = useState({
        firma_adi: '',
        yetkili_kisi: '',
        email: '',
        telefon: '',
        adres: '',
        Durum: 'Aktif'
    });

    useEffect(() => {
        fetchFirmalar();
    }, [searchAd, searchYetkili, durumFilter]);

    const fetchFirmalar = async () => {
        const res = await api.get('/api/firmalar', {
            params: { search_ad: searchAd, search_yetkili: searchYetkili, durum_filter: durumFilter }
        });
        setFirmalar(res.data);
    };

    const resetForm = () => {
        setFormData({ firma_adi: '', yetkili_kisi: '', email: '', telefon: '', adres: '', Durum: 'Aktif' });
        setFormOpen(false);
        setEditId(null);
    };

    const handlePDFDownload = async () => {
        try {
            const res = await api.get('/api/rapor/firmalar', {
                params: { pasif_dahil: showPasif },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `firmalar_rapor_${new Date().toISOString().split('T')[0]}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            alert('PDF indirme başarısız: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.firma_adi.trim()) return alert("Firma adı boş olamaz!");
        try {
            if (editId) {
                await api.put(`/api/firmalar/${editId}`, formData);
                alert("Firma güncellendi!");
            } else {
                await api.post('/api/firmalar', formData);
                alert("Firma eklendi!");
            }
            resetForm();
            fetchFirmalar();
        } catch { alert("İşlem başarısız!"); }
    };

    const handleEdit = (firma) => {
        setEditId(firma.firma_id);
        setFormData({
            firma_adi: firma.firma_adi || '',
            yetkili_kisi: firma.yetkili_kisi || '',
            email: firma.Email || '',
            telefon: firma.telefon || '',
            adres: firma.Adres || '',
            Durum: firma.Durum || 'Aktif'
        });
        setFormOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu firmayı silmek istediğinize emin misiniz?")) return;
        try {
            await api.delete(`/api/firmalar/${id}`);
            fetchFirmalar();
        } catch { alert("Silme işlemi başarısız!"); }
    };

    const handleToggleDurum = async (firma) => {
        const yeniDurum = firma.Durum === 'Aktif' ? 'Pasif' : 'Aktif';
        if (!window.confirm(`${firma.firma_adi} firmasını ${yeniDurum} yapmak istediğinize emin misiniz?`)) return;
        try {
            await api.put(`/api/firmalar/${firma.firma_id}`, {
                firma_adi: firma.firma_adi,
                yetkili_kisi: firma.yetkili_kisi || '',
                email: firma.Email || '',
                telefon: firma.telefon || '',
                adres: firma.Adres || '',
                Durum: yeniDurum
            });
            fetchFirmalar();
        } catch { alert("Durum değiştirme başarısız!"); }
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const filteredFirmalar = showPasif ? firmalar : firmalar.filter(f => f.Durum !== 'Pasif');

    const sortedFirmalar = [...filteredFirmalar].sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';
        if (typeof aVal === 'string') aVal = aVal.toLowerCase();
        if (typeof bVal === 'string') bVal = bVal.toLowerCase();
        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const SortableHeader = ({ label, sortKey }) => (
        <th style={{ ...p12, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort(sortKey)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {label}
                <ArrowUpDown size={14} color={sortConfig.key === sortKey ? '#3b82f6' : '#9ca3af'} />
            </div>
        </th>
    );

    return (
        <div style={{ padding: '20px', backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

                <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '20px', color: '#3b82f6', textDecoration: 'none' }}>
                    <ArrowLeft size={18} /> Ana Sayfa
                </Link>

                <div style={panelStyle}>
                    <h2 style={{ marginTop: 0 }}><Building2 size={24} style={{ verticalAlign: 'middle', marginRight: '10px' }} /> Firma Yönetimi</h2>

                    {/* FİLTRELEME PANELİ */}
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap', padding: '15px', backgroundColor: '#f9fafb', borderRadius: '10px' }}>
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Firma Adı</label>
                            <input type="text" placeholder="Firma adı ara..." value={searchAd} onChange={e => setSearchAd(e.target.value)} style={inputBase} />
                        </div>
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Yetkili Kişi</label>
                            <input type="text" placeholder="Yetkili ara..." value={searchYetkili} onChange={e => setSearchYetkili(e.target.value)} style={inputBase} />
                        </div>
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Durum</label>
                            <select value={durumFilter} onChange={e => setDurumFilter(e.target.value)} style={inputBase}>
                                <option value="">Tümü</option>
                                <option value="Aktif">Aktif</option>
                                <option value="Pasif">Pasif</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <button onClick={() => { setSearchAd(''); setSearchYetkili(''); setDurumFilter(''); }} style={{ ...saveBtn, backgroundColor: '#6b7280' }}>
                                Temizle
                            </button>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center' }}>
                        <button onClick={() => { setFormOpen(!formOpen); if (formOpen) resetForm(); }} style={{ ...saveBtn, backgroundColor: '#8b5cf6' }}>
                            <PlusCircle size={18} style={{ marginRight: '8px' }} />
                            {formOpen ? "İptal" : "Yeni Firma Ekle"}
                        </button>
                        <button onClick={handlePDFDownload} style={{ ...saveBtn, backgroundColor: '#10b981' }}>
                            <FileDown size={18} style={{ marginRight: '8px' }} />
                            PDF Rapor İndir
                        </button>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '14px', marginLeft: '10px' }}>
                            <input type="checkbox" checked={showPasif} onChange={e => setShowPasif(e.target.checked)} />
                            Pasif Firmaları Göster
                        </label>
                    </div>

                    {formOpen && (
                        <form onSubmit={handleSubmit} style={{ marginBottom: '20px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '12px' }}>
                            <h4 style={{ marginTop: 0 }}>{editId ? "Firma Düzenle" : "Yeni Firma"}</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                                <div>
                                    <label style={labelStyle}>Firma Adı *</label>
                                    <input type="text" value={formData.firma_adi} onChange={e => setFormData({ ...formData, firma_adi: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Yetkili Kişi</label>
                                    <input type="text" value={formData.yetkili_kisi} onChange={e => setFormData({ ...formData, yetkili_kisi: e.target.value })} style={inputBase} />
                                </div>
                                <div>
                                    <label style={labelStyle}>Email</label>
                                    <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} style={inputBase} />
                                </div>
                                <div>
                                    <label style={labelStyle}>Telefon</label>
                                    <input type="text" value={formData.telefon} onChange={e => setFormData({ ...formData, telefon: e.target.value })} style={inputBase} />
                                </div>
                                <div style={{ gridColumn: 'span 2' }}>
                                    <label style={labelStyle}>Adres</label>
                                    <input type="text" value={formData.adres} onChange={e => setFormData({ ...formData, adres: e.target.value })} style={inputBase} />
                                </div>
                                <div>
                                    <label style={labelStyle}>Durum</label>
                                    <select value={formData.Durum} onChange={e => setFormData({ ...formData, Durum: e.target.value })} style={inputBase}>
                                        <option value="Aktif">Aktif</option>
                                        <option value="Pasif">Pasif</option>
                                    </select>
                                </div>
                            </div>
                            <button type="submit" style={{ ...saveBtn, backgroundColor: editId ? '#f59e0b' : '#10b981', marginTop: '20px' }}>
                                {editId ? "Güncelle" : "Kaydet"}
                            </button>
                        </form>
                    )}

                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '900px' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>
                                    <SortableHeader label="ID" sortKey="firma_id" />
                                    <SortableHeader label="Firma Adı" sortKey="firma_adi" />
                                    <SortableHeader label="Yetkili Kişi" sortKey="yetkili_kisi" />
                                    <SortableHeader label="Email" sortKey="Email" />
                                    <SortableHeader label="Telefon" sortKey="telefon" />
                                    <SortableHeader label="Adres" sortKey="Adres" />
                                    <SortableHeader label="Durum" sortKey="Durum" />
                                    <th style={p12}>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedFirmalar.map(f => (
                                    <tr key={f.firma_id} style={{ borderBottom: '1px solid #f3f4f6', opacity: f.Durum === 'Pasif' ? 0.5 : 1 }}>
                                        <td style={p12}>{f.firma_id}</td>
                                        <td style={p12}><strong>{f.firma_adi}</strong></td>
                                        <td style={p12}>{f.yetkili_kisi || '-'}</td>
                                        <td style={p12}>{f.Email || '-'}</td>
                                        <td style={p12}>{f.telefon || '-'}</td>
                                        <td style={p12}>{f.Adres || '-'}</td>
                                        <td style={p12}>
                                            <button onClick={() => handleToggleDurum(f)} style={{ ...iconBtn, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                {f.Durum === 'Aktif' ? (
                                                    <><ToggleRight size={22} color="#10b981" /> <span style={{ color: '#10b981', fontSize: '12px' }}>Aktif</span></>
                                                ) : (
                                                    <><ToggleLeft size={22} color="#ef4444" /> <span style={{ color: '#ef4444', fontSize: '12px' }}>Pasif</span></>
                                                )}
                                            </button>
                                        </td>
                                        <td style={{ ...p12, whiteSpace: 'nowrap' }}>
                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                <button onClick={() => handleEdit(f)} style={iconBtn} title="Düzenle"><Edit2 size={18} color="#f59e0b" /></button>
                                                {isAdmin && <button onClick={() => handleDelete(f.firma_id)} style={iconBtn} title="Sil"><Trash2 size={18} color="#ef4444" /></button>}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const inputBase = { padding: '12px', borderRadius: '8px', border: '1px solid #ddd', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151' };
const saveBtn = { color: 'white', border: 'none', borderRadius: '8px', padding: '12px 20px', cursor: 'pointer', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' };
const iconBtn = { border: 'none', background: 'none', cursor: 'pointer', marginRight: '8px' };
const p12 = { padding: '12px' };

export default FirmaYonetimi;
